require('./bootstrap');
require('./_global');
require('./components/vue-declarator');
